import { classnames } from "@/utils";
import styles from "./ProgressBar.module.scss";
import { useOnboarding } from "@/hooks/useOnboarding";
import { onboardingGraph } from "@/data/onboarding";
import { useFlowConfig } from "@/hooks/useFlowConfig";
import { computeProgress } from "@/data/flows/progress";

export default function ProgressBar() {
  const { currentQuestionId } = useOnboarding();
  const flowConfig = useFlowConfig();
  const currentStep = onboardingGraph[currentQuestionId];
  let type = "standard";
  const flowProgress = computeProgress(flowConfig, currentStep);

  if (currentStep.type === "disqualification") {
    type = "disqualification";
  }

  const progressStyle = {
    "--progress": `${flowProgress * 100}%`,
  } as React.CSSProperties;

  if (currentStep.disqualificationType === "lowRisk") {
    return null;
  }

  return (
    <div className={classnames([styles.wrapper, styles[type]])}>
      <div className={styles.progress} style={progressStyle}></div>
    </div>
  );
}
